// 塞尔维亚语
const sr = {
  common: {
    notSupport: 'Vaš pregledač ne podržava režim celog ekrana',
    loadFail: 'Učitavanje teme nije uspelo',
    noPermission: 'Žao nam je, nemate dozvolu za pristup toj stranici',
    backHome: 'Povratak na početnu stranicu',
    noExit: 'Stranica koju pokušavate da otvorite ne postoji',
    serverError: 'Žao nam je, došlo je do greške na serveru',
    slide: 'Prevucite udesno',
    veryHigh: 'Veoma visok',
    high: 'Visok',
    target: 'Cilj',
    urgentLow: 'Veoma nizak',
    agpNoData: 'AGP izveštaj zahteva najmanje 5 dana podataka za generisanje',
    noDataStr: 'Nema podataka',
    setting: 'Podešavanje',
    personInfo: 'Osnovni podaci',
    updatePwd: 'Promeni lozinku',
    upHead: 'Otpremi slike',
    inRange: 'U opsegu',
    normal: 'Normalno',
    low: 'Nizak',
    previous: 'Prethodno',
    next: 'Dalje',
    search: 'Pretraga',
    reset: 'Resetuj',
    cancel: 'Otkаži',
    ok: 'U redu',
    confirm: 'Potvrdi',
    save: 'Sačuvaj',
    submit: 'Pošalji',
    successful: 'Uspešno',
    pleaseEnter: 'Molimo unesite',
    pleaseSelect: 'Molimo izaberite',
    success: 'Uspeh',
    confirmLogout: 'Da li ste sigurni da želite da se odjavite?',
    updateSuccessed: 'Ažuriranje je uspešno',
    warning: 'Upozorenje',
    date: 'Datum',
    start: 'Početak',
    end: 'Kraj',
    sevenDays: '7 dana',
    fourteenDays: '14 dana',
    thirtyDays: '30 dana',
    signOut: 'Odjavi se',
    personalInformation: 'Lični podaci',
    email: 'E-mail',
    name: 'Ime',
    mobile: 'Mobilni',
    dateOfBirth: 'Datum rođenja',
    gender: 'Pol',
    diabeteType: 'Tip dijabetesa',
    dateOfDignose: 'Godina dijagnoze',
    remarks: 'Napomene',
    optionMale: 'Muški',
    optionFemale: 'Ženski',
    optionUnknow: 'Ne želim da navedem',
    noDiabetes: 'Bez dijabetesa',
    diabeteTypeI: 'Tip I',
    diabeteTypeII: 'Tip II',
    diabeteSpecial: 'Posebno',
    diabeteGestational: 'Gestacijski dijabetes',
    diabeteOthers: 'Ostalo',
    ruleMsgEmail: 'Unesite e-mail',
    ruleMsgName: 'Unesite ime',
    ruleMsgMobile: 'Unesite broj telefona',
    ruleMsgBirthday: 'Molimo izaberite datum rođenja',
    ruleMsgSex: 'Molimo izaberite pol',
    ruleMsgDiabeteType: 'Molimo izaberite tip dijabetesa',
    ruleMsgDateOfDignose: 'Molimo izaberite godinu dijagnoze',
    ruleMsgRemarks: 'Unesite napomene',
    ruleMsgCorrectMobile: 'Unesite ispravan broj telefona',
    oldPassword: 'Stara lozinka',
    newPassword: 'Nova lozinka',
    confirmPassword: 'Potvrdite lozinku',
    ruleMsgOldPassword: 'Unesite staru lozinku',
    ruleMsgNewPassword: 'Unesite novu lozinku',
    ruleMsgConfirmPassword: 'Potvrdite lozinku',
    passwordInconsistent: 'Unosi lozinke se ne poklapaju',
    passwordModifySuccessed:
      'Vaša lozinka je resetovana, molimo prijavite se ponovo!',
    monday: 'Pon',
    tuesday: 'Uto',
    wednesday: 'Sre',
    thursday: 'Čet',
    friday: 'Pet',
    saturday: 'Sub',
    sunday: 'Ned',
    sn: 'SN',
    startDate: 'Datum početka',
    days: 'dana',
    pdfDate: 'Cilj',
    close: 'zatvori',
    inputTip: 'Unesite ključne reči za pretragu',
    polarization: 'Uređaj se inicijalizuje',
    hour: 'č',
    minutes: 'min',
    seconds: 'sek',
    reportDownLoadTip: 'Vaš izveštaj nije generisan već 5 dana.',
    age: 'godine',
    goal: 'Cilj',
    expired: 'Senzor je istekao',
    lastTime: 'Vreme poslednjeg osvežavanja',
    timeZone: 'Vremenska zona'
  },
  route: {
    login: 'Prijavi se',
    forget: 'Zaboravili ste lozinku',
    home: 'Početna',
    glucoseReport: 'Izveštaj o glukozi',
    sessionReport: 'Izveštaj o sesiji',
    eventList: 'Lista događaja',
    followerList: 'Lista pratilaca',
    followerListQ: 'Zahtevi posmatrača',
    settings: 'Podešavanja',
    profile: 'Profil'
  },
  login: {
    rememberMe: 'Zapamti me',
    forgetPassword: 'Zaboravljena lozinka',
    agree: 'Prijavom se slažete sa FurCarer',
    privacyPolicy: 'Politika privatnosti',
    CGMUser: 'CGM korisnik',
    follower: 'Pratilac',
    ruleMsgPassword: 'Unesite lozinku',
    login: 'Prijavi se',
    phonePlacehold: 'Unesite broj telefona',
    codePlacehold: 'Unesite verifikacioni kod',
    phoneTip: 'Putem telefona',
    emialTip: 'Putem e-maila',
    codeTip: 'Dobavi verifikacioni kod',
    reGetTip: 'Ponovo preuzmi'
  },
  layout: {
    collapseUp: 'Sakrij meni',
    collapseDown: 'Proširi meni',
    refresh: 'Osveži',
    backHome: 'Početna',
    helpCenter: 'Centar za pomoć',
    fullScreen: 'Ceo ekran'
  },
  forget: {
    ruleMsgCode: 'Unesite kod',
    sendCode: 'Pošalji kod',
    tipsMsgSendSuccess: 'Verifikacioni kod je uspešno poslat!',
    tipsMsgModifySuccess: 'Izmena lozinke uspešna'
  },
  home: {
    todaysGlucose: 'Glukoza danas',
    todaysOverview: 'Pregled danas',
    maxGlucose: 'Maks. glukoza',
    minGlucose: 'Min. glukoza',
    avgGlucose: 'Prosečna glukoza',
    maxmumVariation: 'Maksimalna varijacija',
    glucose: 'Glukoza',
    tir: 'TIR',
    latestGlucose: 'Poslednja glukoza',
    todayPercentage: '% dana u različitim opsezima',
    fourHour: '4 sata',
    eightHour: '8 sati',
    twelveHour: '12 sati',
    twentyFourHour: '24 Hour',
    glucoseOnly: 'Samo glukoza',
    sessionOverview: 'Pregled sesije',
    glocuseMetrics: 'Metričke vrednosti glukoze',
    agp: 'AGP',
    dailyGlucose: 'Dnevna glukoza',
    sessionGlucose: 'Glukoza u sesiji',
    standTir: 'Standardni TIR',
    customTir: 'Prilagođeni TIR',
    cancleGz: 'Otprati',
    cancleText: 'Da li želite da otpratite trenutnog korisnika?',
    helpCenterTip: 'Funkcija još nije dostupna'
  },
  glucoseReport: {
    statics: 'Statistika',
    sixHour: 'TIR za 6 sati',
    avgGlucose: 'Prosečna glukoza',
    maxGlucose: 'Maksimalna glukoza',
    minGlucose: 'Minimalna glukoza',
    cv: 'CV',
    high: 'Broj visokih vrednosti',
    low: 'Broj niskih vrednosti',
    normal: 'Broj normalnih vrednosti',
    tir: 'TIR',
    estimatedA1c: 'Procenjeni HbA1c',
    min: 'Min',
    avg: 'Prosek',
    max: 'Maks',
    maxVariation: 'Maksimalna varijacija'
  },
  glucoseProfile: {
    avg: 'Prosek',
    sd: 'SD',
    cv: 'CV'
  },
  eventList: {
    all: 'Sve',
    bg: 'BG',
    meal: 'Obrok',
    sport: 'Sport',
    insulin: 'Insulin',
    alert: 'Upozorenje',
    eventType: 'Tip događaja',
    description: 'Opis',
    note: 'Napomena',
    highAlert: 'upozorenje',
    calibration: 'Kalibracija',
    meds: 'Lekovi',
    time: 'Vreme',
    detail: 'Detalji',
    weigt: 'Težina'
  },
  followerList: {
    title: 'Korisnici pod nadzorom',
    tabTitle: 'Upravljanje pratiocima',
    refreshText:
      'Automatsko osvežavanje (lista korisnika se osvežava svakih 30 sekundi)',
    addText: 'Dodaj',
    dataText: 'Podaci preuzeti',
    timeText: 'minuta',
    hourText: 'sati',
    agoText: 'pre',
    tableEmail: 'Unesite broj naloga',
    searchPlacehold: 'Molimo unesite broj naloga za pretragu',
    pending: 'Na čekanju',
    approved: 'Odobreno',
    rejected: 'Odbijeno',
    addFollower: 'Dodaj pratioca',
    editFollower: 'Izmeni pratioca',
    tableName: 'Ime',
    tableAddTime: 'Vreme dodavanja',
    tableStatus: 'Status',
    tableApproved: 'Odobreno',
    tableReject: 'Odbij',
    tableStartSharing: 'Započni deljenje',
    tableStopSharing: 'Zaustavi deljenje',
    op: 'Operacija',
    sharing: 'Deljenje',
    notSharing: 'Nema deljenja',
    tableRemove: 'ukloni',
    note: 'Napomena',
    message: 'Poruka',
    ruleMsgEmailEmpty: 'Molimo unesite e-mail za pretragu',
    ruleMsgNote: 'Molimo unesite napomenu',
    ruleMsgMessage: 'Molimo ostavite poruku',
    ruleMsgEmailCorrect: 'Molimo unesite ispravnu e-mail adresu',
    formAcknowledge:
      'Potvrđujem da dodavanjem pratioca ovom korisniku omogućavam uvid u moje podatke',
    sendFollowRequest: 'Pošalji zahtev za praćenje',
    setNote: 'Postavi napomenu',
    tipsAcknowledge:
      'Molimo označite polje – potvrđujete da dodavanjem pratioca ovom korisniku omogućavate uvid u vaše podatke',
    stopSharing: 'Zaustavi deljenje',
    startSharing: 'Započni deljenje',
    removeUser: 'Ukloni korisnika',
    confirmStopSharing:
      'Da li ste sigurni da želite da prekinete deljenje glukoze sa ovim korisnikom?',
    confirmStartSharing:
      'Da li ste sigurni da želite da započnete deljenje glukoze sa ovim korisnikom?',
    confirmRemove:
      'Da li ste sigurni da želite da uklonite ovog korisnika sa liste?',
    approvedFollower: 'Odobren pratilac',
    rejectFollower: 'Odbij pratioca',
    confirmApproved:
      'Da li ste sigurni da želite da odobrite ovaj zahtev za praćenje?',
    confirmReject:
      'Da li ste sigurni da želite da odbijete ovaj zahtev za praćenje?',
    addTime: 'Vreme dodavanja',
    check: 'Proveri',
    remove: 'Ukloni',
    removeUserTitle:
      'Da li ste sigurni da želite da uklonite ovog korisnika sa liste?'
  },
  settings: {
    title: 'Podešavanja nivoa glukoze',
    unitSet: 'Podešavanje jedinica',
    targetSet: 'Podešavanje prilagođenog TIR-a',
    alertSet: 'Podešavanja upozorenja',
    highAlert: 'Upozorenje na visoke vrednosti',
    lowAlert: 'Upozorenje na niske vrednosti',
    urgentLow: 'Hitno niska vrednost',
    urgentHigh: 'Hitno visoka vrednost',
    target: 'Cilj'
  },
  pdf: {
    dailyStatistics: 'Dnevna statistika',
    title: 'AGP izveštaj',
    page: 'Stranica',
    generated: 'Generisano',
    lage: 'LAGE',
    mage: 'MAGE',
    modd: 'MODD',
    range: 'Vreme u ciljanom opsegu',
    timeInRange: 'Vreme u ciljanom opsegu (TIR)',
    agpTitle: 'Ambulantni profil glukoze (AGP)',
    agpSubTitle:
      'AGP je sažetak vrednosti glukoze tokom izveštajnog perioda, prikazan sa medijanom (50%) i drugim procentilima kao da su se pojavili tokom jednog dana',
    dailyTitle: 'Dnevni profil glukoze',
    dailySubTitle:
      'Svaki dnevni profil predstavlja period od ponoći do ponoći.',
    device: 'Uređaj',
    tDevice: 'Terminalni uređaj',
    print: 'Štampaj',
    model: 'Model',
    deviceSn: 'Serijski broj uređaja',
    effectiveData: 'Efektivni podaci',
    days: 'Dana',
    appVer: 'Verzija aplikacije',
    smartPhoneModel: 'Model pametnog telefona',
    osVersion: 'Verzija operativnog sistema',
    appSetting: 'Podešavanja aplikacije',
    GoalsforType1andType2Diabetes: 'Ciljevi za dijabetes tipa 1 i tipa 2',
    Each1timeinrange15minutes: 'Svaki 1% vremena u opsegu = ~15 minuta',
    note: 'Напомена: Јединица % важи за DCCT стандард, док јединица mmol/mol важи за IFCC стандард.'
  },
  field: {
    timeCgmActive: 'Vreme aktivnog CGM',
    gmi: 'GMI',
    gri: 'GRI',
    eHbA1c: 'eHbA1c',
    avgPerDay: 'Prosečno kalibrisanje po danu',
    glucoseAbility: 'Varijabilnost glukoze',
    lage: 'LAGE',
    mage: 'MAGE',
    tar: 'TAR',
    tbr: 'TBR',
    calibrations: 'Broj kalibracija'
  },
  agp: {
    agpTitle: 'Ambulantni profil glukoze (AGP)',
    centerLine: 'Medijana',
    areaLine: 'Interval',
    target: 'Ciljani opseg'
  },
  basic: {
    customTir: 'Prilagođeni TIR',
    bloodTip: 'Podešavanja podsetnika za glukozu',
    bloodUnit: 'Jedinica glukoze',
    highTip: 'Upozorenje na visoku glukozu',
    lowTip: 'Upozorenje na nisku glukozu',
    unitText: 'Automatsko podešavanje na osnovu zemlje ili regiona',
    selectTip: 'Kliknite na ikonu da izaberete ili poništite izbor datuma',
    selectAll: 'Izaberi sve'
  },
  report: {
    threeMonth: 'Poslednja 3 meseca',
    sixMonth: 'Skoro 6 meseci',
    yearText: 'Prošla godina',
    showAll: 'Prikaži sve',
    all: 'Sve',
    selectDate: 'Izaberi vremenski opseg',
    to: 'do',
    startDt: 'Datum početka',
    endDt: 'Datum završetka',
    betaTest: 'Beta testiranje',
    bloodData: 'Podaci o glukozi',
    userCount: 'Korisnički nalog'
  },
  petDetail: {
    variety: 'Rasa',
    type: 'Tip insulina',
    freq: 'Učestalost insulina',
    lente: 'Lente',
    insulin: 'Insulin Glargin',
    pzi: 'PZI',
    nph: 'NPH',
    detemir: 'Detemir'
  },
  pdfReport: {
    title: 'AGP izveštaj',
    snNumber: 'Serijski broj',
    page: 'Stranica',
    createTime: 'Generisano',
    petInfo: 'Podaci o ljubimcu',
    petName: 'Ime ljubimca',
    birthday: 'Datum rođenja',
    freq: 'Učestalost insulina',
    petType: 'Vrsta ljubimca',
    age: 'Starost',
    registerType: 'Tip šprica',
    basicBloodData: 'Metričke vrednosti glukoze',
    dbText: 'Vreme u ciljanom opsegu (TIR)',
    target: 'Ciljevi za dijabetes tipa 1 i tipa 2',
    recordTime: 'Vreme beleženja',
    tag: 'oznaka',
    event: 'Događaj',
    eventDetail: 'Detalji događaja',
    mulityText: 'Grafikon trenda glukoze za više dana',
    mulitySubText:
      'Dnevni profili glukoze za više dana predstavljaju vremenski interval jednog ciklusa uređaja',
    avageBlood: 'Prosečna glukoza',
    bloodText: 'MODD',
    highTip: 'Upozorenje na visoke vrednosti glukoze',
    lowTip: 'Upozorenje na niske vrednosti glukoze',
    cat: 'Mačka',
    dog: 'Pas',
    country: 'Zemlja',
    insulinDose: 'Doza insulina',
    weightUnit: 'kg'
  },
  eventDetail: {
    Empty: 'Prazno',
    Breakfast: 'Doručak',
    Lunch: 'Ručak',
    Dinner: 'Večera',
    Before_Sleep: 'Pre spavanja',
    Extra: 'Ekstra',
    Short_acting: 'Brzodelujući',
    Pre_mixed: 'Pre-miksovani',
    Long_acting: 'Dugodelujući',
    Middle_acting: 'Srednjedejstvujući',
    hour: 'č',
    minutes: 'min',
    After_Breakfast: 'Posle doručka',
    Before_Lunch: 'Pre ručka'
  }
};

export default sr;
